(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name print.controller:PrintCtrl
     *
     * @description
     *
     */
    angular
        .module('print')
        .controller('PrintDutySheetCtrl', PrintDutySheetCtrl);

    function PrintDutySheetCtrl($stateParams, PrintService, DutySheetService, MessageService) {
      console.log("$PrintDutySheetCtrl stateParams : ", $stateParams);
        var vm = this;
        vm.ctrlName = 'PrintDutySheetCtrl';
        vm.model = {
        	searchCriteria : {
    			fromDate : $stateParams.fromDateStr,
    			toDate : $stateParams.toDateStr,
    			fromTime : $stateParams.fromTimeStr,
    			toTime : $stateParams.toTimeStr,
    			JourneyLogNo : $stateParams.journeyLogNumberStr,
    			aircraftType : $stateParams.aircraftModel,
    			crewType : $stateParams.crewType,
    			airport : $stateParams.airPortCode,
    			isDestinationOnly :$stateParams.isDestinationOnly
    			},
          dutySheetHidePersonalDetailsEnabled :$stateParams.dutySheetHidePersonalDetailsEnabled,
            dutySheetData :{
            	duties:[],
            	adaptedDuties:[],
            	otherDuties : {
    				standByDetails : [],
    				deadHeadingDetails : [],
    				readyToWorkDetails : [],
    				otherDutyTypeDetails : []
    			}
        	}
        };

        function loadData(){
        	//DutySheetService.setDutySheetSearchRequest(vm.model.searchCriteria);
        	getDuties(vm.model.searchCriteria);
			getOtherDuties(vm.model.searchCriteria);
        };

        function getDuties(searchRequest) {
			DutySheetService.searchDuties(function(duties) {
				vm.model.dutySheetData.duties = DutySheetService.getFormattedDuties(duties);
				adaptDuties(vm.model.dutySheetData.duties);
			}, function(error) {
				MessageService.error(error);
			},searchRequest);

		};

		function getOtherDuties(searchRequest) {
			getStandByDetails(searchRequest);
			getDeadHeadingDetails(searchRequest);
			getReadyToWorkDetails(searchRequest);
			getOtherDutyTypeDetails(searchRequest);
		};

		function getStandByDetails(searchRequest) {
			DutySheetService.searchStandByDetails(function(standByDetails) {
				vm.model.dutySheetData.otherDuties.standByDetails = standByDetails;
			}, function(error) {
				MessageService.error(error);
			},searchRequest);
		}
		;

		// load dead heading details
		function getDeadHeadingDetails(searchRequest) {
			DutySheetService.searchDeadHeadingDetails(function(
					deadHeadingDetails) {
				vm.model.dutySheetData.otherDuties.deadHeadingDetails = deadHeadingDetails;
			}, function(error) {
				MessageService.error(error);
			},searchRequest);
		};

		// load ready to work details
		function getReadyToWorkDetails(searchRequest) {
			DutySheetService.searchReadyToWorkDetails(function(
					readyToWorkDetails) {
				vm.model.dutySheetData.otherDuties.readyToWorkDetails = readyToWorkDetails;
			}, function(error) {
				MessageService.error(error);
			},searchRequest);
		};

		// load other duty type details
		function getOtherDutyTypeDetails(searchRequest) {
			DutySheetService.searchOtherDutyTypeDetails(
				function(otherDutyTypeDetails) {
					vm.model.dutySheetData.otherDuties.otherDutyTypeDetails = otherDutyTypeDetails;
				}, function(error) {
					MessageService.error(error);
				},searchRequest);
		};

		function adaptDuties(duties){
			var flightDuty = [];
			flightDuty = DutySheetService.getFormatFlightDuty(duties);
			//vm.model.dutySheetData.adaptedDuties.push(flightDuty);
		};

		/*function getGroundDuties(){
			DutySheetService.groundDutyDetails(
			function(groundDuties) {
				vm.model.dutySheetData.otherDuties.groundDuties = groundDuties;
			}, function(error) {
				MessageService.error(error);
			});
		}*/

        //Init
        (function () {
                loadData();
        })()

    }
}());
